import {ISubscription} from '@src/@interfaces/services/Events/ISubscription';
import {IDispatcher, IListener} from '@src/@interfaces/services/Events';

export default class Subscription implements ISubscription {
    protected dispatcher: IDispatcher | null = null;
    protected event: string | string[] | null = null;
    protected listener: IListener<any> | null = null;

    constructor(
        dispatcher: IDispatcher,
        event: string | string[],
        listener: IListener<any>,
    ) {
        this.dispatcher = dispatcher;
        this.event = event;
        this.listener = listener;
    }

    unsubscribe(): void {
        if (this.dispatcher == null) {
            return;
        }

        this.dispatcher.forget(this.event as any, this.listener as any);

        this.dispatcher = this.event = this.listener = null;
    }
}
